export function popupBanner() {
  const banner = document.getElementById('js-popupBanner');
  const trigger = document.getElementById('js-popupBannerTrigger');
  if (!(banner || trigger)) return;

  const hideBanner = (nav) => {
    nav.classList.remove('_show');
  };
  const showBanner = (nav) => {
    nav.classList.add('_show');
  };

  const observerFunction = (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        hideBanner(banner);
      } else {
        showBanner(banner);
      }
    });
  };

  const observerTrigger = new IntersectionObserver(observerFunction, {
    root: null,
    rootMargin: '-99% 0px -1% 0px',
    threshold: 0,
  });

  const executeObserver = (observer) => {
    observer.observe(trigger);
  };

  executeObserver(observerTrigger);

  // ポップアップバナーを閉じる
  const closes = document.querySelectorAll('.js-popupClose');
  // closeをクリックしたら、l-popupBanner を非表示 display none
  closes.forEach((close) => {
    close.addEventListener('click', () => {
      const popup = close.closest('.l-popupBanner');
      popup.classList.add('_hidden');
    });
  });
}
